export const downloadBlob = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

export const getFileNameFromHeader = (cd: string | null) => {
    if (!cd) return "data.xlsx";
    const star = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (star?.[1]) {
        try { return decodeURIComponent(star[1].trim()); } catch { }
    }
    const normal =
        cd.match(/filename\s*=\s*"([^"]+)"/i) ??
        cd.match(/filename\s*=\s*([^;]+)/i);
    return normal?.[1]?.trim() ?? "data.xlsx";
}